module.exports = __webpack_public_path__ + "img/logo.d6d3e8c6.png";